module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//house-range.png?v=42e800b1";